/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getSeaports } from "api/services/common";
import { ISeaportOption } from "types/Common";
import { commonQueryKeys } from "./commonQueryKeys";

export function useGetSeaports(seaportQuery: string, options?: UseQueryOptions<ISeaportOption[]>) {
  return useQuery({
    queryKey: commonQueryKeys.seaports(seaportQuery),
    queryFn: () => getSeaports(seaportQuery).then((res) => res.data.results),
    refetchOnMount: false,
    enabled: seaportQuery.length >= 2,
    staleTime: 60 * 1000, // 1 minute
    ...options,
  }); 
}
